import { useSimpleStoreLocator } from "@locators/components/shared/hooks/useSimpleStoreLocator";
import type { StoreLocatorReturnType } from "@locators/components/shared/hooks/useStoreLocator";

import {
  ACTIVE_MARKER as HORECA_PIN_ACTIVE,
  DEFAULT_MARKER_DARK as HORECA_PIN_DARK,
  DEFAULT_MARKER_LIGHT as HORECA_PIN_LIGHT,
} from "../horeca-locator-icons";
import type { HoReCaLocatorProps } from "../types";

import { useHoReCaStores } from "./useHoReCaStores";

export const useHoReCaLocator = (props: HoReCaLocatorProps, theme: "dark" | "light"): StoreLocatorReturnType => {
  const {
    defaultLat,
    defaultLng,
    defaultZoom,
    storesLimit,
    isOpeningHoursBreaksEnabled = false,
    mapProviderOverride,
    mapInactivityTimeout,
  } = props;
  const defaultStoreIcon = theme === "dark" ? HORECA_PIN_DARK : HORECA_PIN_LIGHT;

  const horecaStoresData = useHoReCaStores({
    storesLimit,
  });

  return useSimpleStoreLocator({
    defaultLat,
    defaultLng,
    defaultZoom,
    isOpeningHoursBreaksEnabled,
    mapProviderOverride,
    mapInactivityTimeout,
    theme,
    storesData: {
      stores: horecaStoresData.horecaStores,
      activeStoreId: horecaStoresData.activeStoreId,
      getStores: horecaStoresData.getHoReCaStores,
      handleSelectStore: horecaStoresData.handleSelectStore,
      getUserMarkerPosition: horecaStoresData.getUserMarkerPosition,
      userMarkerPosition: horecaStoresData.userMarkerPosition,
    },
    defaultStoreIcon,
    activeStoreIcon: HORECA_PIN_ACTIVE,
    translationPrefix: "horeca",
  });
};
